// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// API
import { deleteDryEyeProfile } from "../../../api";

export const useDeleteDryEyeProfile = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (profileId: string) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return deleteDryEyeProfile(token, clinicId, profileId);
      } catch (error) {
        throw error;
      }
    },
    // Invalidate clinic lens query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["dry-eye-profiles", clinicId],
      });
      setSnackbarInfo({
        variant: "success",
        message: t("Option deleted successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Option could not be deleted!"),
      });
    },
  });
};
